//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import get from 'lodash.get'
import Component from '../../base/Component'

const NjImage = Component.extend({
  components: {},
  inheritAttrs: false,
  props: {
    src: {
      type: [String, Object],
      default: null
    },
    disableLazyLoad: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    copyright: {
      type: String,
      default: ''
    },
    usePlaceholder: {
      type: Boolean,
      default: true
    },
    placeholderImage: {
      type: String,
      default: ''
    },
    classes: {
      type: Object,
      default () {
        return {
          aspectRatio: '',
          image: 'object-cover'
        }
      }
    }
  },
  watch: {
    src () {
      // not needed if lazyload is disabeld
      if (this.disableLazyLoad) {
        return
      }
      this.$refs.webp.srcset = ''
      this.$refs.srcset.srcset = ''
    }
  },
  computed: {
    srcImg () {
      return typeof this.src === 'string'
        ? this.src
        : get(this.src, 'opt', null)
          ? this.src.opt
          : null
    },
    srcAlt () {
      if (this.src.alt) {
        return this.src.alt
      }
      return 'imagemage'
    },
    srcset () {
      return get(this.src, 'srcset', false)
    },
    hasAspectRatio () {
      return (
        /aspect-ratio-/.test(this.getThemeClass('aspectRatio')) &&
        'has-aspect-ratio'
      )
    }
  }
})

export default NjImage
